export const billing = {
  subscriptionSettings: "Abonnementeinstellungen",
  taxRates: "Steuersätze",
  numberRanges: "Nummernkreise",
  invoiceTemplate: "Rechnungsvorlage"
};
